export default "__VITE_ASSET__mmlItKFX__"